export const environment = {
  production: true,
  frontend: false,
  i18n: null
};
